import { TExport } from "../types/exports";
import api from "./api";

export const listExports = async (): Promise<TExport[]> => {
  const response = await api.get(
    "insights-p2-:stage/:stage/crm/prospeccao/downloads"
  );

  return response.data;
};
